import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const sandboxBundlerRoute: InvariantJiraRoute = {
	name: 'sandbox-bundler',
	path: '/jira/software/sandbox/bundler',
	exact: true,
};
